<template>
  <q-page padding>
      <span >¯\_(ツ)_/¯</span>
      <p>
        Página não encontrada...
        <strong>(404)</strong>
      </p>
      <button @click="$router.push('/')">Voltar</button>
  </q-page>
</template>

<script>
export default {
  name: 'NotFound'

}
</script>

<style lang="stylus" scoped>
span
  margin-top: 30vh
  color: #dadce0
  font: 10vh/1.25 "Google Sans", "Helvetica Neue", sans-serif
  display block
  text-align center

p
  display block
  text-align center

button
  display flex
  margin-left auto
  margin-right auto

</style>s
